import { z } from "zod";

/**
 * A message a visitor sends from a creator's Contact form: their name, email and words, and the
 * page they wrote from. Creators read them under Members › Inquiries and answer by email; nothing
 * is sent from Drate. `website` is the form's hidden trap field: bots fill it, people never see it.
 */
export const contactMessageInput = z.object({
  name: z.string().trim().min(1).max(100),
  email: z.string().trim().pipe(z.email().max(320)),
  message: z.string().trim().min(1).max(5000),
  pagePath: z
    .string()
    .max(200)
    .regex(/^\/(?!\/)[^?#]*$/)
    .refine(
      (path) =>
        !Array.from(path).some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127),
    )
    .default("/"),
  website: z.string().max(1000).default(""),
});

export const contactMessageListInput = z.object({
  creatorId: z.uuid(),
  search: z.string().trim().max(100).default(""),
  offset: z.number().int().min(0).max(1_000_000).default(0),
  limit: z.number().int().min(1).max(500).default(50),
});

export const contactMessage = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  message: z.string(),
  pagePath: z.string(),
  createdAt: z.string(),
  readAt: z.string().nullable(),
});
export const contactMessagePage = z.object({
  items: z.array(contactMessage),
  total: z.number(),
  unread: z.number(),
});
export type ContactMessage = z.infer<typeof contactMessage>;

/** What the form tells a visitor once their message is saved. */
export const contactMessageSent = "Thank you. Your message was sent.";
